import { render, staticRenderFns } from "./ManualVersionHistory.vue?vue&type=template&id=8a325d6c&scoped=true"
import script from "./ManualVersionHistory.vue?vue&type=script&lang=js"
export * from "./ManualVersionHistory.vue?vue&type=script&lang=js"
import style0 from "./ManualVersionHistory.vue?vue&type=style&index=0&id=8a325d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a325d6c",
  null
  
)

export default component.exports